import React from "react";
import { Heart } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useFavoritos } from "../context/FavoritosContext";
import { useAuth } from "../context/AuthContext";

// Botón de corazón reutilizable. `item` = {tipo, ref_id, titulo, subtitulo, enlace, imagen}
export function FavoriteButton({ item, size = 18, className = "", stop = false }) {
  const { isFav, toggle } = useFavoritos();
  const { user } = useAuth();
  const navigate = useNavigate();
  const activo = isFav(item.ref_id);
  const onClick = (e) => {
    if (stop) { e.preventDefault(); e.stopPropagation(); }
    if (!user) {
      toast.info("Inicia sesión para guardar en favoritos");
      navigate("/login");
      return;
    }
    toggle(item);
  };
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={activo ? "Quitar de favoritos" : "Guardar en favoritos"}
      data-testid={`fav-btn-${item.ref_id}`}
      className={`inline-flex items-center justify-center rounded-full transition-colors ${className}`}
    >
      <Heart size={size} className={activo ? "fill-red-500 text-red-500" : "text-slate-400 hover:text-red-500"} />
    </button>
  );
}
